import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../ui/Logo';
const cols = [{
  title: 'Product',
  links: [{
    label: 'How it works',
    to: '/#how'
  }, {
    label: 'Pricing',
    to: '/pricing'
  }, {
    label: 'Get started',
    to: '/start'
  }]
}, {
  title: 'Performers',
  links: [{
    label: 'Create a profile',
    to: '/onboarding/performer'
  }, {
    label: 'Find gigs',
    to: '/p/discover'
  }]
}, {
  title: 'Organisers',
  links: [{
    label: 'Post an event',
    to: '/onboarding/organiser'
  }, {
    label: 'Review acts',
    to: '/o/review'
  }]
}];
export function SiteFooter() {
  return <footer className="mx-auto max-w-6xl px-5 pb-10 pt-16" data-id="element-418" data-mp="2bvk8l3pgmdis">
      <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr_1fr]" data-id="element-419" data-mp="26wz42s36d7oj">
        <div data-id="element-420" data-mp="22x8ayhq6efgu">
          <Logo data-id="element-421" data-mp="22vnegmkawmgc" />
          <p className="mt-3 max-w-[30ch] text-[15px] text-ink-2" data-id="element-422" data-mp="22w5hq35ds0xr">Bringing live music and the events that need it together.</p>
        </div>
        {cols.map(c => <nav key={c.title} aria-label={c.title} data-id="element-423" data-mp="rha48kih05is">
            <p className="text-sm font-bold" data-id="element-424" data-mp="rjmlevgembus">{c.title}</p>
            <ul className="mt-3 space-y-2" data-id="element-425" data-mp="3lavbr7zrknjx">
              {c.links.map(l => <li key={l.label} data-id="element-426" data-mp="3q9g7ov7zgl2k">
                  <Link to={l.to} className="text-[15px] text-ink-2 underline-offset-4 transition-colors duration-150 hover:text-ink hover:underline" data-id="element-427" data-mp="3q8ep85on0wat">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>)}
      </div>
      <p className="mt-12 border-t border-line pt-6 text-sm text-ink-3" data-id="element-428" data-mp="32hrdf9blpmiz">© 2026 Encorza Co., Ltd. Payments protected by Encorza Pay.</p>
    </footer>;
}